import { useEffect } from "react";

interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  ogType?: "website" | "article";
  keywords?: string;
}

export default function SEOHead({
  title,
  description,
  canonical = "https://alkanesengineering.com",  // No trailing slash for consistency
  ogImage = "https://alkanesengineering.com/og-image.png",
  ogType = "website",
  keywords,
}: SEOHeadProps) {
  useEffect(() => {
    // Update page title
    document.title = title;

    // Update meta description
    let descMeta = document.querySelector('meta[name="description"]');
    if (!descMeta) {
      descMeta = document.createElement("meta");
      descMeta.setAttribute("name", "description");
      document.head.appendChild(descMeta);
    }
    descMeta.setAttribute("content", description);

    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute("href", canonical);

    // Update og:title
    updateOrCreateMetaProperty("og:title", title);
    updateOrCreateMetaProperty("og:description", description);
    updateOrCreateMetaProperty("og:image", ogImage);
    updateOrCreateMetaProperty("og:type", ogType);
    updateOrCreateMetaProperty("og:url", canonical);

    // Update Twitter tags
    updateOrCreateMetaProperty("twitter:title", title);
    updateOrCreateMetaProperty("twitter:description", description);
    updateOrCreateMetaProperty("twitter:image", ogImage);
    updateOrCreateMetaProperty("twitter:url", canonical);

    // Update keywords if provided
    if (keywords) {
      let keywordsMeta = document.querySelector('meta[name="keywords"]');
      if (!keywordsMeta) {
        keywordsMeta = document.createElement("meta");
        keywordsMeta.setAttribute("name", "keywords");
        document.head.appendChild(keywordsMeta);
      }
      keywordsMeta.setAttribute("content", keywords);
    }
  }, [title, description, canonical, ogImage, ogType, keywords]);

  return null;
}

function updateOrCreateMetaProperty(property: string, content: string) {
  let meta = document.querySelector(`meta[property="${property}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("property", property);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}
